import register from '../util/init'
import {getOffset, toggle} from '../util/tools'
// import {PHONE_MAX} from './constants'

// NOTE shared js for books + documentary-writing

class initPage {
  constructor (container) {
    this.container = container
    this.windowWidth = null

    // init load scroll down if we have a 'fake' hash
    const urlParams = new URLSearchParams(window.location.search)
    this.embed = urlParams.get('book') || urlParams.get('documentary-writing')
    const embedEl = document.getElementById(this.embed)

    if (this.embed && embedEl) {
      window.setTimeout(() => {
        window.scroll({
          top: getOffset(embedEl).top, // includes a slight buffer
          left: 0,
          behavior: 'smooth'
        })
      }, 1000)
    } else {
      // DISABLED fallback no param request
      // document.querySelector('.profile.expanded').getAttribute('id')
    }

    return {
      resize: (w, h) => {
        this.windowWidth = w
      },
      scroll: (top, left) => {}
    }
  }
}
register('.books-content', initPage)
register('.documentary-writing-content', initPage)



// WEBPACK FOOTER //
// ./assets/j/src/books.js